// polyfills.ts - Must be imported first before any other modules
import { Buffer } from 'buffer'
import process from 'process'

// Set up global polyfills immediately
if (typeof globalThis !== 'undefined') {
  // Polyfill for globalThis environment
  globalThis.global = globalThis.global ?? globalThis
  globalThis.Buffer = Buffer
  globalThis.process = process
  
  // Ensure Buffer.from is available with fallback
  if (!Buffer.from) {
    (Buffer as any).from = function(data: any, encoding?: any) {
      return new Buffer(data, encoding)
    }
  }
}

if (typeof window !== 'undefined') {
  // Polyfill for window environment
  (window as any).global = window.global ?? window
  ;(window as any).Buffer = Buffer
  ;(window as any).process = process
}

// Export for explicit importing if needed
export { Buffer, process } 